import Challenge from '../../model/Challenge'
import ChallengeBucket from '../../model/ChallengeBucket'
import type { TeamSizeBounds } from '../../logic/teamSizeUtils'

export interface ChallengeContext {
  challengeId: string
  challenge: Challenge
  buckets: ChallengeBucket[]
  bucketById: Map<string, ChallengeBucket>
  bucketByName: Map<string, ChallengeBucket>
  goal: number
  restDaysRequired: number
  teamSizeMin: number
  teamSizeMax: number
  teamSizeTarget: number
}

export function buildChallengeContext(
  challenge: Challenge,
  buckets: ChallengeBucket[],
): ChallengeContext {
  return {
    challengeId: challenge.id,
    challenge,
    buckets,
    bucketById: new Map(buckets.map((bucket) => [bucket.id, bucket])),
    bucketByName: new Map(buckets.map((bucket) => [bucket.name, bucket])),
    goal: challenge.goal,
    restDaysRequired: challenge.restDaysRequired,
    teamSizeMin: challenge.teamSizeMin,
    teamSizeMax: challenge.teamSizeMax,
    teamSizeTarget: challenge.teamSizeTarget,
  }
}

export function teamSizeBoundsFromContext(
  context: Pick<ChallengeContext, 'teamSizeMin' | 'teamSizeMax' | 'teamSizeTarget'>,
): TeamSizeBounds {
  return {
    teamSizeMin: context.teamSizeMin,
    teamSizeMax: context.teamSizeMax,
    teamSizeTarget: context.teamSizeTarget,
  }
}
